<!--
 @description 数据字典
 @date 2018/11/21
-->
<template>
  <div class="dataDictionary__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="0" input-width="auto">
      <el-form-item>
        <el-input v-model="searchForm.name" :placeholder="$t('dataDictionary.databaseName')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          @click="search(true)" 
          v-g-rac="gRac('dataDictionary_search')" 
          v-text="$t('common.search')"></el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 16px;">
      <el-button type="primary" 
        @click="addDatabase" 
        v-g-rac="gRac('dataDictionary_add')" 
        v-text="$t('common.add')"></el-button>
    </div>
    <el-table-extend
      :data="tableData"
      :head="tableHead"
      :currentChange="currentChange"
      :sizeChange="sizeChange"
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('dataDictionary.table.operate')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <dialog-form
      id="dictionaryDiaForm"
      :title="dictionaryDiaTitle"
      :visible.sync="dialogDiaVis" 
      :model="dialogForm"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :confirm-fun="dialogConfirm">
    </dialog-form>
    <el-dialog :closeOnClickModal="false"
      :title="$t('dataDictionary.connectTable')"
      :visible.sync="connectDiaVis"
      width="800px">
      <el-form ref="searchConnectForm" :model="searchConnectForm" :inline="true" label-width="0" input-width="auto">
        <el-form-item>
          <el-select v-model="searchConnectForm.dataBase" 
            filterable :placeholder="$t('common.chooseTips')" 
            @change="searchConnect(true)">
            <el-option
              v-for="item in select_database"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchConnectForm.tableName" :placeholder="$t('dataDictionary.tableName')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            @click="searchConnect(false)"
            v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="connectTableData"
        :head="connectTableHead"
        :currentChange="connectCurrentChange"
        :sizeChange="connectSizeChange"
        border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="connectTableControl" 
            :data="data" 
            :label="$t('dataDictionary.table.operate')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
      <div class="table-dia-wrap mt10" v-show="selectTables.length > 0">
        <div 
          class="each-table" 
          v-for="(item, index) in selectTables"
          :key="item.tableName + index"
          :title="item.databaseName + '-' + item.tableName">
          <i class="icon iconfont icon-amc_circle_close icon-delete" @click="deleteTable(index)"></i>
          <span v-text="item.tableName" class="each-table-name"></span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="connectDiaVis = false" v-text="$t('common.close')"></el-button>
        <el-button @click="saveConnect" v-text="$t('common.confirm')" type="primary"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import dialogForm from '@/components/dialogForm'

  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import dataDictionaryBiz from '@/logic/cmdb/dataDictionaryBiz'
  import validateConfig from '@/utils/validate'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        currentPage: 1,
        perPageCount: 10,
        connectCurrentPage: 1,
        connectPerPageCount: 10,
        select_db: {},
        tableData: {},
        tableHead: [],
        connectTableData: {},
        connectTableHead: [],
        tableControl: [{
          rac: () => this.gRac('dataDictionary_delete'),
          label: this.$t('common.delete'),
          callback: (row, index, data) => {
            this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
              confirmButtonText: this.$t('common.confirm'),
              cancelButtonText: this.$t('common.cancel'),
              type: 'warning'
            }).then(() => {
              dataDictionaryBiz.deleteDic({ id: row.id }).then(() => {
                this.handleSuccess()
              })
            }).catch(() => {})
          }
        }, {
          rac: () => this.gRac('dataDictionary_amend'),
          label: this.$t('common.edit'),
          callback: (row, index, data) => {
            this.dialogForm.name = row.name
            this.dialogForm.desc = row.desc
            this.selectId = row.id
            this.dialogForm.databaseType = Object.keys(this.select_db)
              .filter(item => this.select_db[item] === row.databaseType)[0]
            this.isEdit = true
            this.dialogDiaVis = true
          }
        }, {
          rac: () => this.gRac('dataDictionary_connect'),
          label: this.$t('dataDictionary.connect'),
          callback: (row, index, data) => {
            this.searchConnectForm.tableName = ''
            this.databaseName = this.select_database.length > 0 ? this.select_database
              .filter(item => item.value === this.searchConnectForm.dataBase)[0].label : ''
            this.selectId = row.id
            this.selectTables = row.relationVos ? row.relationVos : []
            this.getDatabaseList().then(() => {
              this.searchConnect()
              this.connectDiaVis = true
            })
          }
        }, {
          rac: () => this.gRac('dataDictionary_check'),
          label: this.$t('common.check'),
          callback: (row, index, data) => {
            this.$router.push({ name: 'dataDicConfig', query: { id: row.id, database: row.name } })
          }
        }],
        connectTableControl: [{
          label: this.$t('dataDictionary.addTo'),
          callback: (row, index, data) => {
            if (this.selectTables.filter(item => row.id === item.id).length === 0) {
              this.selectTables.push({ ...row, databaseName: this.databaseName })
            }
          }
        }],
        searchForm: {
          name: ''
        },
        dialogForm: {
          name: '',
          databaseType: '',
          desc: ''
        },
        dialogDiaVis: false,
        dialogFormRule: {},
        dialogData: [],
        dictionaryDiaTitle: this.$t('dataDictionary.addDic'),
        isEdit: false,
        connectDiaVis: false,
        select_database: [],
        databaseName: '',
        searchConnectForm: {
          dataBase: '',
          tableName: ''
        },
        selectTables: [],
        selectId: ''
      }
    },
    components: {
      dialogForm
    },
    methods: {
      initTable () {
        this.tableHead = [
          { key: 'name', label: this.$t('dataDictionary.table.name') },
          { key: 'databaseType',
            label: this.$t('dataDictionary.table.databaseType'),
            formatter: 'Dictionary',
            formatterDic: this.select_db },
          { key: 'desc', label: this.$t('dataDictionary.table.desc') }
        ]
      },
      initConnectTable () {
        this.connectTableHead = [
          { key: 'tableName', label: this.$t('dataDictionary.connectTableHead.tableName') },
          { key: 'tableDesc', label: this.$t('dataDictionary.connectTableHead.tableDesc') }
        ]
      },
      async getDBType () {
        await this.dGetDictionaryByCode('databaseType')
        this.select_db = { ...this.dDictionary.databaseType }
        this.setDialogData()
        this.search()
      },
      setDialogData () {
        this.dialogData = [{
          label: this.$t('dataDictionary.name'),
          key: 'name'
        },
        {
          label: this.$t('dataDictionary.databaseType'),
          key: 'databaseType',
          type: 'select',
          select: this.select_db
        },
        {
          label: this.$t('dataDictionary.desc'),
          key: 'desc',
          type: 'textarea'
        }]
        this.dialogFormRule = {
          name: [{ ...validateConfig.common.notEmpty }],
          databaseType: [{ ...validateConfig.common.notEmpty }]
        }
      },
      search (fromClick = false) {
        if (fromClick) {
          this.currentPage = 1
          this.perPageCount = 10
        }
        this.initTable()
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount
        }
        if (this.searchForm.name) {
          searchObj.name = this.searchForm.name
        }
        dataDictionaryBiz.getDic(searchObj).then((data) => {
          this.tableData = data
        })
      },
      // 搜索关联表
      searchConnect (fromSelect = false) {
        if (fromSelect) {
          this.connectCurrentPage = 1
          this.connectPerPageCount = 10
          this.searchConnectForm.tableName = ''
        }
        this.initConnectTable()
        let searchObj = {
          currentPage: this.connectCurrentPage,
          perPageCount: this.connectPerPageCount,
          parentId: this.searchConnectForm.dataBase
        }
        this.databaseName = this.select_database
          .filter(item => item.value === this.searchConnectForm.dataBase)[0].label
        if (this.searchConnectForm.tableName) searchObj.tableName = this.searchConnectForm.tableName
        dataDictionaryBiz.getTable(searchObj).then((data) => {
          this.connectTableData = data
        })
      },
      getDatabaseList () {
        return dataDictionaryBiz.getDic({
          currentPage: 1,
          perPageCount: 999
        }).then((data) => {
          this.select_database = []
          data.dataList.map(item => {
            let obj = {
              value: item.id,
              label: item.name
            }
            this.select_database.push(obj)
          })
          this.searchConnectForm.dataBase = this.select_database[0].value
        })
      },
      currentChange (val) {
        this.currentPage = val
        this.search()
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.search()
      },
      connectCurrentChange (val) {
        this.connectCurrentPage = val
        this.searchConnect()
      },
      connectSizeChange (val) {
        this.connectCurrentPage = 1
        this.connectPerPageCount = val
        this.searchConnect()
      },
      addDatabase () {
        for (let i in this.dialogForm) {
          this.dialogForm[i] = ''
        }
        this.isEdit = false
        this.dialogDiaVis = true
      },
      dialogConfirm (formInfo) {
        if (this.isEdit) {
          formInfo.id = this.selectId
          dataDictionaryBiz.updateDic(formInfo).then(() => {
            this.handleSuccess()
            this.dialogDiaVis = false
          })
        } else {
          dataDictionaryBiz.saveDic(formInfo).then(() => {
            this.handleSuccess()
            this.dialogDiaVis = false
          })
        }
      },
      deleteTable (i) {
        this.selectTables.splice(i, 1)
      },
      saveConnect () {
        let arr = []
        this.selectTables.map((item) => {
          let obj = {
            parentId: item.parentId,
            id: item.id,
            tableName: item.tableName,
            databaseName: item.databaseName
          }
          arr.push(obj)
        })
        dataDictionaryBiz.connectDic({ id: this.selectId, relationVos: arr }).then(() => {
          this.handleSuccess()
          this.connectDiaVis = false
        })
      },
      handleSuccess () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.search()
      }
    },
    watch: {
      isEdit (val) {
        this.dictionaryDiaTitle = val ? this.$t('dataDictionary.amendDic') : this.$t('dataDictionary.addDic')
      }
    },
    mounted () {
      this.getDBType()
    }
  }
</script>

<style scoped>
  .table-dia-wrap {
    border: 1px solid #ddd;
    width: 666px;
    margin: 10px auto 0 auto;
    max-height: 132px;
    overflow-y: scroll;
    padding: 6px 0;
  }
  .each-table {
    width: 120px;
    height: 30px;
    line-height: 24px;
    padding: 0 4px;
    text-align: center;
    display: inline-block;
    position: relative;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .each-table-name {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
  .each-table:hover {
    background: #eaeaea;
    border: 1px solid #ddd;
  }
  .each-table:hover .icon-delete {
    display: block;
  }
  .icon-delete {
    display: none;
    color: #a0a0a0;
    font-size: 18px;
    position: absolute;
    bottom: 18px;
    right: -8px;
  }
  .icon-delete:hover {
    color: #3385ff;
    font-weight: bolder;
  }
</style>